<!-- DIALOG DEPÓSITO -->
<template>
  <v-dialog v-model="depositPix.status" persistent max-width="500">
    <v-card>
      <v-card-title class="mb-0 pb-0">
        <div>
          <h3 class="headline mb-0">
            {{ $t("payment") }}
          </h3>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="mt-3">
          <v-alert type="info" icon="mdi-information" text border="left" dense>
            {{ $t("pixPhysicalPersonAlert") }}
          </v-alert>
        </div>

        <div class="mt-3">
          <span class="mt-4 white--text" v-if="depositPix.chargeId">
            ID {{ $t("invoice") }}:
            <strong>
              {{ depositPix.chargeId }}
            </strong>
          </span>
          <br />
          <span class="mt-4 white--text ">
            {{ $t("value") }}:
            <strong>
              {{ getPortugueseMoney(depositPix.value) }}
            </strong>
          </span>
        </div>

        <v-divider class="my-4" />

        <div class="d-flex flex-column align-center">
          <p class="white--text">
            {{ $t("newInvoices.readQrCode") }}
          </p>
          <v-img
            :src="depositPix.imgQrcode"
            max-height="250px"
            max-width="250px"
          ></v-img>
        </div>
      </v-card-text>

      <div class="my-2 white--text text-center text-lowercase">
        {{ $t("or") }}
      </div>

      <div
        class="px-6 pb-6"
        @click="$copy(depositPix.codeQr)"
        style="cursor: pointer;"
      >
        <v-textarea
          :value="depositPix.codeQr"
          disabled
          outlined
          hide-details
          class="mb-4"
        />
        <v-btn block color="primary" @click="$copy(depositPix.codeQr)">
          <v-icon small left>mdi-content-copy</v-icon>
          {{ $t("newInvoices.copyPixCode") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "dialog-deposit-pix",
  data: () => ({}),
  computed: {
    depositPix() {
      return this.$store.state.depositPix;
    },
  },
  methods: {
    closeDialog() {
      this.$store.commit("dialogDepositPix", {
        status: false,
        value: "",
        imgQrcode: "",
        codeQr: "",
      });
    },
    getPortugueseMoney(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>
